
import axios from "axios";
import {apiUrl} from '../AxiosAPI' ;  

  
// Create Course Name API post call with rest endpoint 
export const createCourseByAdmin= (CourseData) => axios.post(`${apiUrl}/createCourseByAdmin`,CourseData);  
export const createCourseByAdminV2= (apiData) => axios.post(`${apiUrl}/createCourseByAdminV2`,apiData);  
 
 export const getAllCourseThumbnails = (data) => axios.post(`${apiUrl}/getAllCourseThumbnails`,data);  
 export const createACustomProductByAdmin= (ProductData) => axios.post(`${apiUrl}/createACustomProductByAdmin`,ProductData);  
 export const getProductByProductId= (ProductData) => axios.post(`${apiUrl}/getProductByProductId`,ProductData);  
 export const createLabelsByApp= (ProductData) => axios.post(`${apiUrl}/createLabelsByApp`,ProductData);  
 export const createPricePlanByAdmin= (PriceData) => axios.post(`${apiUrl}/createPricePlanByAdmin`,PriceData);  
 export const getAPricePlanByProductId= (PriceData) => axios.post(`${apiUrl}/getAPricePlanByProductId`,PriceData);  
 
 

